export default __webpack_public_path__ + "static/media/checkedNew.4a95bb00.svg";